import { PRODUCT_SELECTED } from "./types";

export const selectProduct = (product) => async (dispatch) => {
  dispatch({
    type: PRODUCT_SELECTED,
    payload: product,
  });
};
